import { type ObjectValuesUnionType } from '../utils/typing';

import { Licence, Licences } from './common';

export const MarketIds = Object.freeze({
  MARKET_ID_1X2: 1,
  MARKET_ID_SOCCER_QUALIFICATION: 2,
  MARKET_ID_SOCCER_WINNER_BRACKET_FINAL_WINNER: 3,
  MARKET_ID_SOCCER_LOOSER_BRACKET_FINAL_WINNER: 4,
  MARKET_ID_FIRST_HALF_1X2: 60,
  MARKET_ID_DOUBLE_CHANCE: 10,
  MARKET_ID_FIRST_HALF_DOUBLE_CHANCE: 63,
  MARKET_ID_EXACT_NUMBER_OF_GOALS: 21,
  MARKET_ID_COMPETITOR1_EXACT_NUMBER_OF_GOALS: 23,
  MARKET_ID_COMPETITOR2_EXACT_NUMBER_OF_GOALS: 24,
  MARKET_ID_HALFTIME_EXACT_NUMBER_OF_GOALS: 71,
  MARKET_ID_COMPETITOR1_HALFTIME_EXACT_NUMBER_OF_GOALS: 72,
  MARKET_ID_COMPETITOR2_HALFTIME_EXACT_NUMBER_OF_GOALS: 73,
  MARKET_ID_CLEAN_SHEET: 9035,
  MARKET_ID_COMPETITOR1_CLEAN_SHEET: 31,
  MARKET_ID_COMPETITOR2_CLEAN_SHEET: 32,
  MARKET_ID_COMPETITOR1_WIN_TO_NIL: 33,
  MARKET_ID_COMPETITOR2_WIN_TO_NIL: 34,
  MARKET_ID_COMPETITOR1_FIRST_HALF_CLEAN_SHEET: 76,
  MARKET_ID_COMPETITOR2_FIRST_HALF_CLEAN_SHEET: 77,
  MARKET_ID_COMPETITOR1_SECOND_HALF_CLEAN_SHEET: 96,
  MARKET_ID_COMPETITOR2_SECOND_HALF_CLEAN_SHEET: 77,
  MARKET_ID_NEXT_GOALSCORER: 38,
  MARKET_ID_ANYTIME_GOALSCORER: 40,
  MARKET_ID_HALFTIME_FULLTIME: 47,
  MARKET_ID_GOALSCORER_TWO_GOALS: 898,
  MARKET_ID_GOALSCORER_THREE_GOALS: 899,
  MARKET_ID_MULTIPLE_GOALSCORER: 9001,
  MARKET_ID_FIRST_GOALSCORER: 9003,
  MARKET_ID_LAST_GOALSCORER: 9004,
  MARKET_ID_LAST_GOALSCORER_2: 39,
  MARKET_ID_SCORE_AND_WIN: 9005,
  MARKET_ID_DOUBLE_CHANCE_GOALSCORER: 9006,
  MARKET_ID_TRIPLE_CHANCE_GOALSCORER: 9007,
  MARKET_ID_BOTH_PLAYERS_TO_SCORE: 9008,
  MARKET_ID_WINNING_MARGIN: 15,
  MARKET_ID_PENALTY_SHOOTOUT_WINNING_MARGIN: 126,
  MARKET_ID_BASEBALL_WINNING_MARGIN: 255,
  MARKET_ID_ICE_HOCKEY_WINNING_MARGIN: 409,
  MARKET_ID_BASKETBALL_WINNING_MARGIN: 290,
  MARKET_ID_HIGHEST_SCORING_HALF: 52,
  MARKET_ID_1ST_HALF_MULTIGOALS: 552,
  MARKET_ID_DARTS_HIGHEST_SCORING_PLAYER: 377,
  MARKET_ID_DARTS_MOST_180S: 381,
  MARKET_ID_BOTH_TEAMS_TO_SCORE: 29,
  MARKET_ID_HALFTIME_BOTH_TEAMS_TO_SCORE: 75,
  MARKET_ID_DRAW_NO_BET: 11,
  MARKET_ID_FIRST_HALF_DRAW_NO_BET: 64,
  MARKET_ID_TEAM_TO_SCORE_NTH_GOAL: 8,
  MARKET_ID_ODD_EVEN_TOTAL: 26,
  MARKET_ID_ODD_EVEN_TOTAL_INCL_OT: 229,
  MARKET_ID_COMPETITOR1_ODD_EVEN_TOTAL: 27,
  MARKET_ID_COMPETITOR2_ODD_EVEN_TOTAL: 28,
  MARKET_ID_FIRST_HALF_ODD_EVEN_TOTAL: 74,
  MARKET_ID_RESULT_AND_BOTH_TEAMS_TO_SCORE: 35,
  MARKET_ID_HALFTIME_RESULT_AND_BOTH_TEAMS_TO_SCORE: 78,
  MARKET_ID_DOUBLE_CHANCE_AND_BOTH_TEAMS_TO_SCORE: 546,
  MARKET_ID_DOUBLE_CHANCE_AND_TOTAL: 547,
  MARKET_ID_WHEN_WILL_NTH_GOAL_BE_SCORED: 101,
  MARKET_ID_MULTIGOALS: 548,
  MARKET_ID_HALFTIME_MULTIGOALS: 552,
  MARKET_ID_COMPETITOR1_MULTIGOALS: 549,
  MARKET_ID_COMPETITOR2_MULTIGOALS: 550,
  MARKET_ID_1X2_AFTER_N_MINUTES: 9036,
  MARKET_ID_WINNER_INCL_OT: 219,
  MARKET_ID_TEAM_TO_SCORE_LAST_GOAL: 9,
  MARKET_ID_COMPETITOR1_NO_BET: 12,
  MARKET_ID_COMPETITOR2_NO_BET: 13,
  MARKET_ID_COMPETITOR1_TO_WIN_BOTH_HALVES: 48,
  MARKET_ID_COMPETITOR2_TO_WIN_BOTH_HALVES: 49,
  MARKET_ID_COMPETITOR1_TO_SCORE_IN_BOTH_HALVES: 56,
  MARKET_ID_COMPETITOR2_TO_SCORE_IN_BOTH_HALVES: 57,
  MARKET_ID_TOTAL_AND_BOTH_TEAMS_TO_SCORE: 36,
  MARKET_ID_RANGE_OF_GOALS: 25,
  MARKET_ID_OVERTIME_NEXT_SCORER: 9052,
  MARKET_ID_GOALSCORER_DUO: 9102,
  MARKET_ID_GOALSCORER_TRIO: 9103,

  // Soccer

  MARKET_ID_SOCCER_SCORER_PERIOD_1_HT: 9072,
  MARKET_ID_SOCCER_SCORER_PERIOD_2_HT: 9073,
  MARKET_ID_SOCCER_SCORER_PERIOD_BOTH_HT: 9099,
  MARKET_ID_SOCCER_SCORER_PERIOD_10MINUTES: 9100,
  MARKET_ID_SOCCER_SCORER_PERIOD_15MINUTES: 9101,
  MARKET_ID_SOCCER_COMPETITOR_GOAL_TYPE_PENALTY: 9091,
  MARKET_ID_SOCCER_COMPETITOR_GOAL_TYPE_HEAD: 9090,
  MARKET_ID_SOCCER_COMPETITOR_GOAL_TYPE_FREEKICK: 9089,
  MARKET_ID_SOCCER_MULTI_SCORER_1_HT: 9074,
  MARKET_ID_SOCCER_MULTI_SCORER_2_HT: 9075,
  MARKET_ID_SOCCER_SCORER_OVERTIME: 9112,
  MARKET_ID_SOCCER_MULTI_SCORER_OVERTIME: 9113,
  MARKET_ID_SOCCER_SCORER_OVERTIME_1_HT: 9114,
  MARKET_ID_SOCCER_SCORER_OVERTIME_2_HT: 9115,
  MARKET_ID_SOCCER_EXACT_GOALS: 9145,
  MARKET_ID_SOCCER_TEAM_OVER_GOALS: 9146,
  MARKET_ID_SOCCER_HOME_GOALS: 9151,
  MARKET_ID_SOCCER_AWAY_GOALS: 9152,
  MARKET_ID_SOCCER_EXACT_GOALS_HT: 9159,
  MARKET_ID_SOCCER_TEAM_OVER_GOALS_HT: 9160,
  MARKET_ID_SOCCER_TOTAL_WINS_HOME: 9163,
  MARKET_ID_SOCCER_TOTAL_WINS_AWAY: 9164,
  MARKET_ID_SOCCER_EXACT_DRAW: 9168,
  MARKET_ID_SOCCER_DECISIVE_PLAYER: 9173,
  MARKET_ID_SOCCER_NUMBER_OF_SHOTS_BY_PLAYER: 1183,
  MARKET_ID_SOCCER_NUMBER_OF_SHOTS_ON_TARGET_BY_PLAYER: 1185,
  MARKET_ID_SOCCER_NUMBER_OF_PASSES_BY_PLAYER: 1187,
  MARKET_ID_SOCCER_NUMBER_OF_TACKLES_BY_PLAYER: 1189,
  MARKET_ID_SOCCER_NUMBER_OF_CARDS_BY_PLAYER: 1191,
  MARKET_ID_SOCCER_PLAYER_PROP_ASSISTS: 770,
  MARKET_ID_SOCCER_PLAYER_PROP_SHOTS: 776,
  MARKET_ID_SOCCER_PLAYER_PROP_SHOTS_ON_GOAL: 777,
  MARKET_ID_SOCCER_PLAYER_PROP_PASSES: 778,
  MARKET_ID_SOCCER_PLAYER_PROP_TACKLES: 780,

  // Tennis
  MARKET_ID_WINNER: 186,
  MARKET_ID_TOTAL_GAMES: 189,
  MARKET_ID_TOTAL_SETS: 314,
  MARKET_ID_GAME_WINNER: 210,
  MARKET_ID_NTH_SET_WINNER: 202,
  MARKET_ID_NTH_SET_TOTAL_GAMES: 204,
  MARKET_ID_NTH_SET_TIEBREAK: 206,
  MARKET_ID_NTH_SET_CORRECT_SCORE: 207,
  MARKET_ID_NTH_SET_MTH_GAME_CORRECT_SCORE: 214,
  MARKET_ID_NTH_SET_MTH_GAME_TO_DEUCE: 212,
  MARKET_ID_POINT_WINNER: 218,
  MARKET_ID_GAME_HANDICAP: 187,
  MARKET_ID_SET_HANDICAP: 188,
  MARKET_ID_NTH_SET_GAME_HANDICAP: 203,
  MARKET_ID_NTH_SET_WINNER_AND_TOTAL_GAMES: 9033,
  MARKET_ID_NTH_SET_TIEBREAK_CORRECT_SCORE: 894,
  MARKET_ID_NTH_SET_TIEBREAK_POINT_WINNER: 9034,
  MARKET_ID_PLAYER_ACES: 9137,
  MARKET_ID_PLAYER_ACES_COMPETITOR1: 9138,
  MARKET_ID_PLAYER_ACES_COMPETITOR2: 9139,

  // Totals
  MARKET_ID_TOTAL: 18,
  MARKET_ID_TOTAL_INCL_OT: 225,
  MARKET_ID_COMPETITOR1_TOTAL: 19,
  MARKET_ID_COMPETITOR2_TOTAL: 20,
  MARKET_ID_COMPETITOR1_TOTAL_INCL_OT: 227,
  MARKET_ID_COMPETITOR2_TOTAL_INCL_OT: 228,
  MARKET_ID_FIRST_HALF_TOTAL: 68,
  MARKET_ID_FIRST_HALF_COMPETITOR1_TOTAL: 69,
  MARKET_ID_FIRST_HALF_COMPETITOR2_TOTAL: 70,
  MARKET_ID_SECOND_HALF_TOTAL: 90,
  MARKET_ID_SECOND_HALF_TOTAL_INCL_OT: 232,
  MARKET_ID_10_MINUTES_TOTAL: 107,
  MARKET_ID_OVERTIME_TOTAL: 116,
  MARKET_ID_PENALTY_TOTAL: 127,
  MARKET_ID_PENALTY_COMPETITOR1_TOTAL: 128,
  MARKET_ID_PENALTY_COMPETITOR2_TOTAL: 129,
  MARKET_ID_RESULT_AND_TOTAL: 37,
  MARKET_ID_WHICH_TEAM_TO_SCORE: 30,
  MARKET_ID_TOTAL_AFTER_N_MINUTES: 9037,

  // Asian handicaps
  MARKET_ID_HANDICAP: 16,
  MARKET_ID_HANDICAP_INCL_OT: 223,
  MARKET_ID_HT_HANDICAP: 66,
  MARKET_ID_SECOND_HALF_HANDICAP: 88,
  MARKET_ID_SECOND_HALF_HANDICAP_INCL_OT: 231,
  MARKET_ID_HANDICAP_WX: 7016,
  MARKET_ID_HT_HANDICAP_WX: 7066,
  MARKET_ID_HANDICAP_TEXT: 8016,

  // Correct score
  MARKET_ID_HALFTIME_CORRECT_SCORE: 81,
  MARKET_ID_CORRECT_SCORE: 199,
  MARKET_ID_CORRECT_SCORE_MULTICHOICE: 551,

  // Dynamic correct score markets
  MARKET_ID_DYNAMIC_CORRECT_SCORE: 41,
  MARKET_ID_DYNAMIC_FIRST_HALF_CORRECT_SCORE: 80,
  MARKET_ID_DYNAMIC_OVERTIME_CORRECT_SCORE: 118,
  MARKET_ID_DYNAMIC_OVERTIME_FIRST_HALF_CORRECT_SCORE: 121,
  MARKET_ID_DYNAMIC_FUTSAL_CORRECT_SCORE: 401,
  MARKET_ID_DYNAMIC_FUTSAL_FIRST_HALF_CORRECT_SCORE: 402,
  MARKET_ID_DYNAMIC_ICE_HOCKEY_CORRECT_SCORE: 430,

  // Outrights
  MARKET_ID_CHAMPIONSHIP_FREE_TEXT_MARKET: 534,
  MARKET_ID_SHORT_TERM_FREE_TEXT_MARKET: 535,
  MARKET_ID_FREE_TEXT_MULTIWINNER_MARKET: 536,
  MARKET_ID_FREE_TEXT_MARKET: 559,

  // Basketball
  MARKET_ID_NTH_QUARTER_DRAW_NO_BET: 302,
  MARKET_ID_NTH_QUARTER_HANDICAP: 303,
  MARKET_ID_NTH_QUARTER_ODD_EVEN_TOTAL: 304,
  MARKET_ID_NTH_QUARTER_RESULT: 235,
  MARKET_ID_NTH_QUARTER_TOTAL: 236,
  MARKET_ID_WILL_THERE_BE_OVERTIME: 220,
  MARKET_ID_BASKETBALL_NUMBER_OF_POINTS_PLAYER_HEAD_TO_HEAD: 9203,
  MARKET_ID_BASKETBALL_NUMBER_OF_ASSISTS_PLAYER_HEAD_TO_HEAD: 9204,
  MARKET_ID_BASKETBALL_NUMBER_OF_REBOUNDS_PLAYER_HEAD_TO_HEAD: 9205,

  // Basketball scorers
  MARKET_ID_PLAYER_POINTS_TEAM1: 9001,
  MARKET_ID_PLAYER_POINTS_TEAM2: 9011,
  MARKET_ID_PLAYER_REBOUNDS_TEAM1: 9005,
  MARKET_ID_PLAYER_REBOUNDS_TEAM2: 9015,
  MARKET_ID_PLAYER_ASSISTS_TEAM1: 9006,
  MARKET_ID_PLAYER_ASSISTS_TEAM2: 9016,
  MARKET_ID_PLAYER_POINT_SPECIAL: 921,
  MARKET_ID_PLAYER_PASS_OVER_UNDER: 922,
  MARKET_ID_PLAYER_REBOUND_OVER_UNDER: 923,
  MARKET_ID_PLAYER_3POINTS_OVER_UNDER: 924,
  MARKET_ID_PLAYER_POINT_REBOUND_ASSIST_OVER_UNDER: 9053,
  MARKET_ID_PLAYER_POINT_PASS_OVER_UNDER: 9054,
  MARKET_ID_PLAYER_PASS_REBOUND_OVER_UNDER: 9055,
  MARKET_ID_PLAYER_POINT_REBOUND_OVER_UNDER: 9056,
  MARKET_ID_PLAYER_DOUBLE_CHANCE: 9057,
  MARKET_ID_2PLAYERS_SUM_POINT: 9058,
  MARKET_ID_3PLAYERS_SUM_POINT: 9059,
  MARKET_ID_PLAYER_POINTS: 9060,
  MARKET_ID_PLAYER_PASS: 9067,
  MARKET_ID_PLAYER_REBOUND: 9068,
  MARKET_ID_PLAYER_3POINTS: 9070,
  MARKET_ID_PLAYER_INTERCEPT_OVER_UNDER: 9174,
  MARKET_ID_PLAYER_BLOCK_OVER_UNDER: 9175,
  MARKET_ID_PLAYER_LOST_BALL_OVER_UNDER: 9176,
  MARKET_ID_TOTAL_PLAYER_INTERCEPT_BLOCK_OVER_UNDER: 9177,
  MARKET_ID_TOTAL_PLAYER_POINTS_REBOUND_ASSIST: 9178,
  MARKET_ID_TOTAL_PLAYER_POINTS_ASSIST: 9179,
  MARKET_ID_TOTAL_PLAYER_ASSIST_REBOUND: 9180,
  MARKET_ID_TOTAL_PLAYER_POINTS_REBOUND: 9181,
  MARKET_ID_PLAYER_INTERCEPT: 9182,
  MARKET_ID_PLAYER_BLOCK: 9183,
  MARKET_ID_PLAYER_LOST_BALL: 9184,
  MARKET_ID_TOTAL_PLAYER_INTERCEPT_BLOCK: 9185,

  // Cotes boostées
  MARKET_ID_BOOSTED_BET: 9038,
  MARKET_ID_BIG_BOOSTED_BET: 9039,
  MARKET_ID_XMAS_BOOSTED_BET: 9108,

  // Ice Hockey scorers
  MARKET_ID_ICE_HOCKEY_ANYTIME_GOALSCORER: 968,
  MARKET_ID_ICE_HOCKEY_MULTI_GOALSCORER: 9001,
  MARKET_ID_ICE_HOCKEY_SCORER_FIRST_PERIOD: 9116,
  MARKET_ID_ICE_HOCKEY_SCORER_SECOND_PERIOD: 9117,
  MARKET_ID_ICE_HOCKEY_SCORER_THIRD_PERIOD: 9118,
});

export type MarketId = ObjectValuesUnionType<typeof MarketIds>;

export const NewMarketIdsByLicence = new Proxy<Record<Licence, Array<MarketId>>>(
  {
    // specific new markets for each licence
    [Licences.FR]: [],
    [Licences.ES]: [],
    [Licences.IT]: [],
    [Licences.DE]: [],
    [Licences.PT]: [],
  },
  {
    get: (origin, key: Licence) => {
      // new markets for every licence
      const everyLicencesValue = [
        MarketIds.MARKET_ID_BASKETBALL_NUMBER_OF_POINTS_PLAYER_HEAD_TO_HEAD,
        MarketIds.MARKET_ID_BASKETBALL_NUMBER_OF_ASSISTS_PLAYER_HEAD_TO_HEAD,
        MarketIds.MARKET_ID_BASKETBALL_NUMBER_OF_REBOUNDS_PLAYER_HEAD_TO_HEAD,
      ];

      const foundValue = origin[key];

      if (!foundValue) {
        return everyLicencesValue;
      }

      return [...everyLicencesValue, ...foundValue];
    },
  },
);
